/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('InformationsService', function($q, identity, Informations) {
    let InformationsService;
    return new (InformationsService = class InformationsService {
        constructor() {
            this.informations       = [];
            this.promise            = null;
            this.archiving_promises = { };

            identity.$promise.then(() => {
                return this.fetchInformations();
            });
        }

        fetchInformations() {

            if (null !== this.promise) { return this.promise; }

            const deferred = $q.defer();

            this.promise = Informations
            .query({
                login: identity.login})
            .$promise;

            this.promise.then(informations => {
                this.informations = informations;

                return deferred.resolve(this.informations);
        }).catch(error => deferred.reject(error)).finally(() => {
                return this.promise = null;
            });

            return deferred.promise;
        }

        archiveInformations(ids) {
            const deferred = $q.defer();

            Informations.validate(ids).$promise.then(() => {
                for (const id of ids) {
                    this.informations = this.informations.filter(information => +information.id !== +id);
                }

                return deferred.resolve({ });
            })
                .catch(error => deferred.reject(error)).finally(() => {
                return archiving_promise = null;
            });

            return deferred.promise;
        }

        getInformations() {
            return this.informations;
        }
    });
});

